import { render } from "./MerchantInfo.vue?vue&type=template&id=f965dbac&scoped=true&ts=true"
import script from "./MerchantInfo.vue?vue&type=script&lang=ts"
export * from "./MerchantInfo.vue?vue&type=script&lang=ts"

import "./MerchantInfo.vue?vue&type=style&index=0&id=f965dbac&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f965dbac"]])

export default __exports__